import { type ReactNode } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/auth-context';

export function Layout({ children }: { children: ReactNode }) {
  const { logout } = useAuth();
  const location = useLocation();

  return (
    <div className="min-h-screen bg-slate-950">
      <header className="border-b border-slate-800 bg-slate-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-14">
            <div className="flex items-center gap-6">
              <Link to="/" className="text-orange-500 font-bold text-lg">MojoFinds Admin</Link>
              <nav className="flex gap-4">
                <Link
                  to="/"
                  className={`text-sm ${location.pathname === '/' ? 'text-white' : 'text-slate-400 hover:text-slate-200'}`}
                >
                  Scans
                </Link>
                <Link
                  to="/users"
                  className={`text-sm ${location.pathname.startsWith('/users') ? 'text-white' : 'text-slate-400 hover:text-slate-200'}`}
                >
                  Users
                </Link>
                <Link
                  to="/beta"
                  className={`text-sm ${location.pathname === '/beta' ? 'text-white' : 'text-slate-400 hover:text-slate-200'}`}
                >
                  Beta
                </Link>
                <Link
                  to="/finops"
                  className={`text-sm ${location.pathname === '/finops' ? 'text-white' : 'text-slate-400 hover:text-slate-200'}`}
                >
                  FinOps
                </Link>
                <Link
                  to="/debug"
                  className={`text-sm ${location.pathname === '/debug' ? 'text-white' : 'text-slate-400 hover:text-slate-200'}`}
                >
                  Debug Test
                </Link>
                <Link
                  to="/prompts"
                  className={`text-sm ${location.pathname === '/prompts' ? 'text-white' : 'text-slate-400 hover:text-slate-200'}`}
                >
                  Prompts
                </Link>
              </nav>
            </div>
            <button
              onClick={logout}
              className="text-sm text-slate-400 hover:text-white"
            >
              Sign Out
            </button>
          </div>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        {children}
      </main>
    </div>
  );
}
